import React, { CSSProperties, ReactNode } from 'react';

import ThreeDotsLoader from '../Loaders/ThreeDotsLoader';

import './_buttonComponent.scss';

interface ButtonComponentProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  type?: 'button' | 'submit' | 'reset';
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
  style?: CSSProperties;
  variant?: 'primary' | 'secondary' | 'danger' | 'text' | string;
  showLoading?: boolean;
  loaderColor?: string;
  className?: string;
  icon?: ReactNode;
  rightIcon?: ReactNode;
  disabledStyle?: CSSProperties;
  textStyle?: CSSProperties;
  fullWidth?: boolean;
}

const ButtonComponent = React.forwardRef<HTMLButtonElement, ButtonComponentProps>(
  (
    {
      children,
      onClick,
      type = 'button',
      size = 'medium',
      disabled = false,
      style = {},
      variant = 'primary',
      showLoading = false,
      loaderColor = '#fff',
      className = '',
      icon,
      rightIcon,
      disabledStyle = {},
      textStyle = {},
      fullWidth = false,
      ...rest
    },
    ref
  ) => {
    const clickHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
      if (showLoading) return;
      if (onClick) onClick(e);
    };

    const text = () => {
      if (!showLoading) {
        return (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '6px',
              alignItems: 'center',
              fontSize: '16px',
              fontWeight: '400',
              ...textStyle,
            }}>
            {icon}
            {children}
            {rightIcon}
          </div>
        );
      }
      return null;
    };

    return (
      <>
        {disabled ? (
          <button
            {...rest}
            className={`${variant}-button custom-button ${className} ${fullWidth ? 'full-width' : ''} ${size}-button`}
            type={'button'}
            disabled={true}
            style={{ ...style, ...disabledStyle }}
            ref={ref}>
            {icon}
            {children}
          </button>
        ) : (
          <button
            {...rest}
            className={`${variant}-button custom-button ${className} ${fullWidth ? 'full-width' : ''} ${size}-button`}
            onClick={clickHandler}
            type={type}
            disabled={disabled}
            style={style}
            ref={ref}>
            {showLoading && <ThreeDotsLoader color={loaderColor} />}
            {text()}
          </button>
        )}
      </>
    );
  }
);

ButtonComponent.displayName = 'ButtonComponent';

export default ButtonComponent;
